import dayjs from 'dayjs';

export const getDayDifference = (startDateArg: string, endDateArg: string) => {
  const startDate = dayjs(startDateArg.slice(0, 10));
  const endDate = dayjs(endDateArg.slice(0, 10));
  return startDate.diff(endDate, 'day');
};
